<template>
  <div class="noticias-wrapper">
    <div class="titulo-gerenciamento">
      <h3>Notícias da Ação</h3>
      <p>
        Acompanhe as notícias submetidas pela coordenação, onde cada uma é
        publicada e o status atual de análise
      </p>
    </div>

    <AnaliseNoticiasPrex :isCoordenacao="true" :acaoId="acaoId" />
  </div>
</template>

<script setup>
import AnaliseNoticiasPrex from "@/components/noticias/AnaliseNoticiasPrex.vue";

defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});
</script>

<style scoped>
.noticias-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  color: var(--cinza-escuro);
}

.titulo-gerenciamento {
  margin-bottom: 10px;
  color: var(--branco);

}

.titulo-gerenciamento h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--branco);

  margin: 0 0 4px;
}

.titulo-gerenciamento p {
  columns: var(--branco);

  font-size: 0.85rem;
  margin: 0;
}
</style>
